// Google Analytics 工具函数

import { GA_MEASUREMENT_ID } from '../config.js';

// 初始化 Google Analytics
export const initGA = () => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined') {
    return;
  }

  // 如果已经初始化，跳过
  if (window.gtag) {
    return;
  }

  // 加载 gtag.js
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // 初始化 gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false // 手动发送页面浏览事件
  });
};

// 跟踪页面浏览
export const trackPageView = (path, title) => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
    page_title: title || document.title
  });
};

// 跟踪事件
export const trackEvent = (action, category, label, value) => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};

// 跟踪协议查看
export const trackProtocolView = (protocolName, protocolId) => {
  trackEvent('view_protocol', 'Protocol', protocolName, protocolId);
};

// 跟踪报告查看
export const trackReportView = (protocolName, protocolId) => {
  trackEvent('view_report', 'Report', protocolName, protocolId);
};

// 跟踪搜索
export const trackSearch = (searchTerm) => {
  trackEvent('search', 'Search', searchTerm);
};

// 跟踪筛选
export const trackFilter = (filterType, filterValue) => {
  trackEvent('filter', 'Filter', `${filterType}: ${filterValue}`);
};

// 跟踪点击
export const trackClick = (elementName, location) => {
  trackEvent('click', 'Interaction', elementName, location);
};

